import { render } from "./Murojatlar.vue?vue&type=template&id=13a91982&scoped=true"
import script from "./Murojatlar.vue?vue&type=script&lang=js"
export * from "./Murojatlar.vue?vue&type=script&lang=js"

import "./Murojatlar.vue?vue&type=style&index=0&id=13a91982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a91982"]])

export default __exports__